import React from 'react';
import './VideoSelfie.scss';
import { useAddClassNameToAppOnMount } from 'hooks/useAddClassNameToAppOnMount';
import { XpressId } from 'components/shared/XpressId/XpressId';
import { useVideoSelfieCapture } from './hooks/useVideoSelfieCapture';
import { withHeaderContext } from 'hocs/withHeaderContext/withHeaderContext';
import { useHideHeaderOnMount } from 'hooks/useHideHeaderOnMount';

export const VideoSelfie = withHeaderContext(
    ({
        acceptedText,
        faceMatch,
        onIdentificationSuccess,
        onIdentificationError,
        headerActions,
        onCloseButtonClick,
    }) => {
        useAddClassNameToAppOnMount('full-height-identification-view');
        useHideHeaderOnMount(headerActions);

        const { accessToken, handleProcessCompleted, handleProcessCancelled, handleProcessError, handleProcessEvents } =
            useVideoSelfieCapture({
                acceptedText,
                faceMatch,
                onIdentificationSuccess,
                onIdentificationError,
                onCloseButtonClick,
            });

        return (
            <div data-testid="videoSelfie-container" className="videoSelfie-container">
                <div className="videoSelfie-frame">
                    <XpressId
                        accessToken={accessToken}
                        onProcessCancelled={handleProcessCancelled}
                        onProcessCompleted={handleProcessCompleted}
                        onProcessError={handleProcessError}
                        onProcessEvents={handleProcessEvents}
                    />
                </div>
            </div>
        );
    }
);
